import { render } from "./LastSeenRenderer.vue?vue&type=template&id=35fd665b"
import script from "./LastSeenRenderer.vue?vue&type=script&lang=js"
export * from "./LastSeenRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__